// import dynamic from "next/dynamic";
// import { Loader } from "rizzui";

// const NoSSR = ({ children }: { children: React.ReactNode }) => <>{children}</>;

// export default dynamic(() => Promise.resolve(NoSSR), {
//   ssr: false,
//   loading: () => <Loader variant="spinner" size="lg" />,
// });

import React from "react";
import { Loader } from "rizzui";

interface NoSSRProps {
  children: React.ReactNode;
}

const NoSSR: React.FC<NoSSRProps> = ({ children }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <Loader variant="spinner" size="lg" />;
  }

  return <>{children}</>;
};

export default NoSSR;
